import React, { Component } from 'react'
import { ReactComponent as FileIcon } from './file.svg'
import {
  extendParentClass,
  extendBaseClass,
  extend,
} from '../../../utils/classes'

export class Item extends Component {
  baseClass = extendParentClass.bind(this)('item')

  extend = extendBaseClass.bind(this)

  render() {
    const { question, answer } = this.props
    const iconClass = this.extend('icon')
    const bodyClass = this.extend('body')
    return (
      <div className={this.baseClass}>
        <div className={iconClass}>
          <FileIcon className={extend(iconClass, 'svg')} />
        </div>
        <div className={bodyClass}>
          <h4>{question}</h4>
          <p>{answer}</p>
        </div>
      </div>
    )
  }
}

export default Item
